module.exports = __webpack_public_path__ + "img/huilv.e2a310d9.png";